import { format, toZonedTime } from 'date-fns-tz';
import qs from 'qs';

import { correctLang } from '@/api/cms/base';

const now = new Date().toISOString();
const weekday = format(toZonedTime(new Date(), 'UTC'), 'EEEE');

export const getCMSSchedulerQuery = () => ({
  $or: [
    {
      scheduler: {
        id: {
          $null: true,
        },
      },
    },
    {
      scheduler: {
        weekday: {
          $eq: weekday,
        },
      },
    },
  ],
});

export const getCMSDurationQuery = () => ({
  $or: [
    {
      duration_from: { $null: true },
      duration_to: { $null: true },
    },
    {
      duration_from: { $lt: now },
      duration_to: { $null: true },
    },
    {
      duration_from: { $null: true },
      duration_to: { $gt: now },
    },
    {
      duration_from: { $lt: now },
      duration_to: { $gt: now },
    },
  ],
});

export const getCMSCountryQuery = (countryCode: string) => [
  {
    $or: [
      { country_codes_exclude: { $null: true } },
      { country_codes_exclude: { $eq: '' } },
      { country_codes_exclude: { $not: { $contains: countryCode } } },
    ],
  },
  {
    $or: [
      { country_codes_include: { $null: true } },
      { country_codes_include: { $eq: '' } },
      { country_codes_include: { $contains: countryCode } },
    ],
  },
];

export const getCMSShowGuestQuery = (isAuthenticated: boolean) =>
  isAuthenticated ? [] : [{ show_guest_toggle: { $eq: true } }];

export const getCMSImageFieldsUrl = (name: string) => ({
  [name]: {
    fields: ['url'],
  },
});

export const getCMSLocale = (language: string) => ({
  locale: [correctLang(language)],
});

export enum CMSSortTypeEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ICMSQuery {
  fields?: string[];
  sort?: string | string[];
  filters?: Record<string, any>;
  populate?: Record<string, any> | 'deep';
  locale?: string[];
  publicationState?: 'live' | 'preview';
  pagination?: {
    page?: number;
    pageSize?: number;
    start?: number;
    limit?: number;
  };
}

export const createCMSQuery = (data: ICMSQuery) =>
  qs.stringify(data, { encodeValuesOnly: true });
